import { fehlertext } from '../../api/client'
import { useEnv, useMe } from '../../hooks/queries'
import { zeitText } from '../../lib/ortszeit'
import { useTexte } from '../../texte'

/**
 * Wer wann welchen Wert der `.env` geändert hat (#62) -- die letzten
 * fünfzig, neueste zuerst. Bei Geheimnissen steht nur, dass sie geändert
 * wurden; der Server zeichnet ihre Werte gar nicht erst auf.
 */
export function EnvProtokollCard() {
  const t = useTexte().betrieb
  const me = useMe()
  const env = useEnv(me.data?.may_operate === true)

  if (env.isPending) return <p className="card__lead leise">…</p>
  if (env.isError) {
    return (
      <p className="notice" role="alert">
        {fehlertext(env.error)}
      </p>
    )
  }
  const aenderungen = env.data.changes

  return (
    <div className="card card--seite" data-env-protokoll="">
      <p className="card__lead">{t.protokollLead}</p>
      {aenderungen.length === 0 && <p className="leise">{t.protokollLeer}</p>}
      <div className="stack stack--eng">
        {aenderungen.map((a) => (
          <div className="envzeile" key={a.id} data-env-aenderung={a.key}>
            <div className="envzeile__kopf">
              <code className="envzeile__name">{a.key}</code>
              <span className="envzeile__quelle">
                {t.protokollZeile(a.by ?? t.unbekanntePerson, zeitText(a.at))}
                {a.how === 'undo' ? t.protokollUndo : ''}
              </span>
            </div>
            <p className="envzeile__satz">
              {a.secret ? t.protokollGeheim : t.protokollAlt(a.old_value, a.new_value)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
